import Vue from 'vue';
import Component from 'vue-class-component';
import { TOOLS_ROUTES } from '@/tools/tools.router';
import { Status } from '@/models/status.model';
import { APP_EVENT_BUS } from '@/core/enums/app.enum';

@Component({
  name: 'tools-toolbar'
})
export default class toolsToolbar extends Vue {

  public lastClicked: string = '';
  public status: Status = new Status();

  get organizationId() {
    let institutions: any[] = this.$store.state.ToolsStore.institutionInfo;
    return institutions.length > 0 ? institutions[0].organizationId : null;
  }

  get institutionsLoaded() {
    return this.$store.state.AppStore.institutionsLoaded;
  }

  get instutionInfo(): any[] {
    return this.$store.state.ToolsStore.institutionInfo
  }

  get itemsLoading() {
    return Array(10).fill({}).map((x,i)=>i);
  }

  get canWriteSchoolDay() {
    return this.$store.state.AuthStore.privileges.WriteSchoolDay &&
      this.organizationId;
  }

  get canWriteOrganization() {
    return this.$store.state.AuthStore.privileges.WriteOrganization &&
      this.organizationId;
  }

  get canStudentAdmin() {
    return this.$store.state.AuthStore.privileges.StudentAdmin &&
        this.organizationId;
  }

  get canWriteClass() {
    // return this.$store.state.AuthStore.privileges.WriteClass && 
    //   this.organizationId;
    return true;
  }

  get isTeacher(): boolean{
    return this.$Auth.Store.isPublisher;
  }

  get isStudent(): boolean {
    return this.$Auth.Store.isStudent;
  }

  get canSubstituteTeacherAdmin() {
    return this.$store.state.AuthStore.privileges.SubstituteTeacher;
  }

  get routeName() {
    if(this.$route) {
      return this.$route.name;
    }
    return '';
  }

  get menu() {
    return {
      institutionInformation: {
        name: TOOLS_ROUTES.INSTITUTION_INFORMATION.NAME,
        label: this.$i18n.t('tools.toolbar.institutionInformation'),
        disabled: !this.canWriteOrganization,
        available: true,
      },
      schoolCalendarAdmin: {
        name: TOOLS_ROUTES.SCHOOL_CALENDAR_ADMIN.NAME,
        label: this.$i18n.t('tools.toolbar.schoolCalendarAdmin'),
        disabled: !this.canWriteSchoolDay,
        available: true
      },
      classAdmin: {
        name: 'admin',
        label: this.$i18n.t('tools.toolbar.classAdmin'),
        disabled: this.isStudent || this.$store.getters['AuthStore/isAuthor'],
        available: true
      },
      staffAdmin: {
        name: TOOLS_ROUTES.STAFF_ADMIN.NAME,
        label: this.$i18n.t('tools.toolbar.staffAdmin'),
        disabled: !this.canWriteOrganization,
        available: false
      },
      preferences: {
        name: TOOLS_ROUTES.PREFERENCES.NAME,
        label: this.$i18n.t('tools.toolbar.preferences'),
        disabled: !this.canWriteOrganization,
        available: true
      },
      myInfo: {
        name: TOOLS_ROUTES.MY_INFO.NAME,
        label: this.$i18n.t('tools.toolbar.myInfo'),
        disabled: false,
        available: true
      },
      courseAdmin: {
        label: this.$i18n.t('tools.toolbar.courseAdmin'),
        disabled: true,
        available: true
      },      
      departmentAdmin: {
        label: this.$i18n.t('tools.toolbar.departmentAdmin'),
        disabled: true,
        available: true
      },
      substituteTeacherAdmin: {
        name: TOOLS_ROUTES.SUBSTITUTE_TEACHER_ADMIN.NAME,
        label: this.$i18n.t('tools.toolbar.substituteTeacher'),
        disabled: !this.canSubstituteTeacherAdmin,
        available: true
      },
      familyAdmin: {
        label: this.$i18n.t('tools.toolbar.familyAdmin'),
        disabled: true,
        available: true
      },
      licenseAdmin: {
        label: this.$i18n.t('tools.toolbar.licenseAdmin'),
        disabled: true,
        available: true
      },
      schoolAdmin: {
        label: this.$i18n.t('tools.toolbar.schoolAdmin'),
        disabled: true,
        available: true
      },
      storageAdmin: {
        name: TOOLS_ROUTES.STORAGE_ADMIN.NAME,
        label: this.$i18n.t('tools.toolbar.storageAdmin'),
        disabled: this.isStudent,
        available: true
      },
      studentAdmin: {
        name: TOOLS_ROUTES.STUDENT_ADMIN.NAME,
        label: this.$i18n.t('tools.toolbar.studentAdmin'),
        disabled: !this.canStudentAdmin,
        available: true
      },
      websiteAdmin: {
        label: this.$i18n.t('tools.toolbar.websiteAdmin'),
        disabled: true,
        available: true
      },
      synchronization: {
        name: TOOLS_ROUTES.SYNCHRONIZATION_ADMIN.NAME,
        label: this.$i18n.t('tools.toolbar.synchronization'),
        disabled: false,
        available: true
      },
    }
  }

  get menuFiltered() {
    const menuFiltered: any = {};
    const keys = Object.keys(this.menu);
    keys.forEach(k => {
      if(this.menu[k].available) {
        menuFiltered[k] = this.menu[k];
      }
    });
    return menuFiltered;
  }

  clickedRoute(menu: any) {
    if(!menu.disabled) {
      this.$router.push({ name: menu.name }).catch(() => {});
    }
  }

  init() {
    this.status.setLoad();
  }

  created() {
    if(!this.institutionsLoaded) {
      this.status.setLoading();
      this.$edEventBus.$on(APP_EVENT_BUS.APP_INSTITUTION_READY, this.init);
    } else {
      this.init();
    }
  }

}
